import { MainHeader } from './mainHeader/MainHeader';
import classNames from 'classnames';

import './Header.scss';

export const Header = ({
  children,
  classNameHeader,
  classNameContainer,
  ...r
}) => {
  const _classNameHeader = classNames(
    'common-header flex flex-column w-100',
    classNameHeader
  );
  const _classNameContainer = classNames(
    'common-header-container',
    classNameContainer
  );

  return (
    <div className={_classNameContainer}>
      <header className={_classNameHeader} {...r}>
        {children}
      </header>
    </div>
  );
};

Header.MainHeader = MainHeader;

export default Header
